/** Format a Date as YYYY-MM-DD using local time (not UTC). Returns '' for invalid dates. */
export const formatDate = date => {
  if (!date || typeof date.getTime !== 'function' || Number.isNaN(date.getTime())) {
    return '';
  }
  const yyyy = date.getFullYear();
  const mm = `${date.getMonth() + 1}`.padStart(2, '0');
  const dd = `${date.getDate()}`.padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

/**
 * Parse a strict YYYY-MM-DD string into a local-time Date.
 * Returns null for invalid or non-calendar dates (e.g. 2024-02-31).
 */
export const parseDate = val => {
  if (!val || typeof val !== 'string') return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(val.trim());
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  if (!Number.isInteger(y) || !Number.isInteger(mo) || !Number.isInteger(d)) return null;
  const date = new Date(y, mo - 1, d);
  if (Number.isNaN(date.getTime())) return null;
  if (date.getFullYear() !== y || date.getMonth() !== mo - 1 || date.getDate() !== d) return null;
  return date;
};

/** True when Ti2 integration id is tourplannx (not hostconnect tourplan). */
export const isTourPlanNxIntegration = integrationApp =>
  String(integrationApp || '').toLowerCase() === 'tourplannx';

export const TERMINAL_STATUSES = new Set([
  'success',
  'succeeded',
  'failure',
  'failed',
  'error',
  'completed',
  'stuck',
  'not_found',
  'revoked',
  'canceled',
  'cancelled',
  'terminated',
  'cleared',
]);
